import { MediaEmbed, MediaEmbedProps } from "@/baseComponents";
import { MediaTypes } from "@/types/enums";
import { Box, chakra } from "@chakra-ui/react";
import DOMPurify from "isomorphic-dompurify";
import { MediaData } from "./MediaData";

export interface CustomMediaEmbedProps extends MediaEmbedProps, MediaEmbedData {
  hasBorderRadius?: boolean;
}

export interface MediaEmbedData extends MediaData {
  type?: MediaTypes.Embed;
  embedCode: string;
  isFullWidth?: boolean;
}

export default chakra(MediaVideoEmbed);
export function MediaVideoEmbed({
  hasBorderRadius,
  embedCode,
  isFullWidth,
  ...props
}: CustomMediaEmbedProps) {
  const CustomMediaVideoEmbed = chakra(MediaEmbed);
  return (
    <Box
      borderRadius={
        isFullWidth ? "0 0.75rem 0.75rem 0" : hasBorderRadius ? "xl" : "none"
      }
      {...props}
    >
      <CustomMediaVideoEmbed
        sx={{
          iframe: {
            marginInline: "auto", 
            paddingInline: "2rem", 
            maxWidth: { base: "100%", md: "none" },
          },
        }}
        // aspectRatio={1}
        embedCode={DOMPurify.sanitize(embedCode, {
          ALLOWED_TAGS: ["iframe"],
        })}
      />
    </Box>
  );
}
